// Meetings created from OneBase on the user's own Google or Outlook calendar.
const CALENDAR_PROVIDERS = ["gmail", "ms"]
const STATUS_CANCELLED = "cancelled"

export function isCalendarMeeting(meeting) {
  return CALENDAR_PROVIDERS.includes(meeting?.provider)
}

export function isCancelledMeeting(meeting) {
  return meeting?.status === STATUS_CANCELLED
}

// Only meetings that are still ahead and have a calendar event to change.
export function canChangeCalendarMeeting(meeting, now = Date.now()) {
  return (
    isCalendarMeeting(meeting) &&
    !isCancelledMeeting(meeting) &&
    Boolean(meeting.calendar_event_data?.id) &&
    new Date(meeting.start_datetime).getTime() > now
  )
}

// Cancelled meetings never count as upcoming, even when their time is ahead.
export function splitMeetings(meetings, now = Date.now()) {
  const upcoming = []
  const history = []
  meetings.forEach((meeting) => {
    const isAhead = new Date(meeting.start_datetime).getTime() > now
    if (isAhead && !isCancelledMeeting(meeting)) {
      upcoming.push(meeting)
    } else {
      history.push(meeting)
    }
  })
  return { upcoming, history }
}

export function calendarMeetingErrorMessage(error, fallback) {
  const data = error?.response?.data
  if (!data) return fallback
  const detail = typeof data.detail === "string" ? data.detail : null
  if (detail) {
    return data.reauthorize
      ? `${detail} Reconnect your calendar in Settings and try again.`
      : detail
  }
  if (Array.isArray(data.reason) && data.reason.length) return data.reason[0]
  if (Array.isArray(data.new_datetime) && data.new_datetime.length)
    return data.new_datetime[0]
  return fallback
}

// The message to show when creating a meeting fails. A meeting that clashes with
// one the user already has comes back as 409 with the names in the detail.
export function meetingCreateErrorMessage(error) {
  const data = error?.response?.data
  if (typeof data?.detail === "string" && data.detail) return data.detail
  if (Array.isArray(data?.start_datetime) && data.start_datetime.length)
    return data.start_datetime[0]
  return "The meeting could not be scheduled. Please try again."
}
